import { Badge, defaultIconSize, renderCurrency } from '@synqo/frontend-component-library';
import { IconCashBanknote } from '@tabler/icons-react';

interface PriceBadgeProps {
    price: number;
}

export function PriceBadge({ price }: PriceBadgeProps) {
    return (
        <Badge variant="info" size="sm" type="input">
            <IconCashBanknote size={defaultIconSize} />
            &nbsp;
            {renderCurrency(price)}
        </Badge>
    );
}
